import cleanedFilename from '~/util/cleanedFilename';

export default {
  OVERVIEW_HEADER: `${cleanedFilename(__filename)}-overview-header`,
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  EMPTY_STATE: `${cleanedFilename(__filename)}-empty-state`,
};
